import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_INFOS_LOGISTIQUE_REQUEST: 'FETCH_INFOS_LOGISTIQUE_REQUEST',
    FETCH_INFOS_LOGISTIQUE_SUCCESS: 'FETCH_INFOS_LOGISTIQUE_SUCCESS',
    FETCH_INFOS_LOGISTIQUE_FAILURE: 'FETCH_INFOS_LOGISTIQUE_FAILURE'
};

/**
 * FETCH_INFOS_LOGISTIQUE
 * ActionCreator pour la récuperation des infos logistique sur une pièce
 */
const fetchInfosLogistiqueRequest = () => ({ type: Actions.FETCH_INFOS_LOGISTIQUE_REQUEST });
const fetchInfosLogistiqueSuccess = infosLogistique => ({ type: Actions.FETCH_INFOS_LOGISTIQUE_SUCCESS, infosLogistique });
const fetchInfosLogistiqueFailure = error => ({ type: Actions.FETCH_INFOS_LOGISTIQUE_FAILURE, error });

export const fetchInfosLogistique = (numeroPiece) => async (dispatch, getState) => {
    if (!getState().information.logistique.isInfosLogistiqueLoading) {
        dispatch(fetchInfosLogistiqueRequest());

        try {
            let response = await axios.get(`api/pieces-gestion/${numeroPiece}/infos-logistique`);
            dispatch(fetchInfosLogistiqueSuccess(response.data));
        } catch (error) {
            console.error('fetchInfosLogistique : ', error);
            dispatch(fetchInfosLogistiqueFailure(error));
        }
    }
};

